/**
 * Shared access to the one page-level overlay that CTC renders in Index.vue.
 *
 * Every tab (and every modal a tab opens) used to broadcast a bare boolean on
 * `ctc-show-overlay`, which made the overlay last-writer-wins: whichever
 * component finished first cleared it, even while another was still loading,
 * and a component that was torn down mid-request — a tab switch, or the
 * `lazy` tabs remounting when `ctcSettings` arrives — never sent its `false`
 * at all, so the overlay stayed up for good.
 *
 * Requests now carry the emitting component's uid and Index counts holders, so
 * the overlay drops only once every holder has released it. `beforeDestroy`
 * releases the hold because an in-flight request can no longer do it once the
 * component is gone.
 *
 * Used as a local mixin: `import ctcOverlay from '../js/ctcOverlay';`
 */
export default {
    methods: {
        ctcOverlay(show) {
            this.$root.$emit('ctc-show-overlay', !!show, this._uid);
        }
    },
    beforeDestroy() {
        this.$root.$emit('ctc-show-overlay', false, this._uid);
    }
};
